import React, { useState, useRef } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DocumentUploadZone = ({ onFileUpload, isUploading = false }) => {
  const [isDragOver, setIsDragOver] = useState(false);
  const fileInputRef = useRef(null);

  const handleDragOver = (e) => {
    e?.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = (e) => {
    e?.preventDefault();
    setIsDragOver(false);
  };

  const handleDrop = (e) => {
    e?.preventDefault();
    setIsDragOver(false);
    
    const files = Array.from(e?.dataTransfer?.files);
    const pdfFiles = files?.filter(file => file?.type === 'application/pdf');
    
    if (pdfFiles?.length > 0) {
      onFileUpload(pdfFiles);
    }
  };

  const handleFileSelect = (e) => {
    const files = Array.from(e?.target?.files);
    if (files?.length > 0) {
      onFileUpload(files);
    }
  };

  const handleBrowseClick = () => {
    fileInputRef?.current?.click();
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div
        className={`border-2 border-dashed rounded-lg p-8 text-center transition-legal ${
          isDragOver
            ? 'border-primary bg-primary/5' :'border-border hover:border-primary/50'
        }`}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        <input
          ref={fileInputRef}
          type="file"
          multiple
          accept=".pdf"
          onChange={handleFileSelect}
          className="hidden"
        />
        
        <div className="flex flex-col items-center space-y-4">
          <div className={`w-16 h-16 rounded-full flex items-center justify-center transition-legal ${
            isDragOver ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground'
          }`}>
            <Icon name="Upload" size={24} />
          </div>
          
          <div className="space-y-2">
            <h3 className="text-lg font-medium text-foreground">
              {isDragOver ? 'Drop files here' : 'Upload Contract Documents'}
            </h3>
            <p className="text-sm text-muted-foreground">
              Drag and drop PDF files here, or click to browse
            </p>
            <p className="text-xs text-muted-foreground">
              Supported formats: PDF • Maximum size: 10MB per file
            </p>
          </div>
          
          <div className="flex items-center space-x-3">
            <Button
              variant="default"
              onClick={handleBrowseClick}
              disabled={isUploading}
              loading={isUploading}
              iconName="FolderOpen"
              iconPosition="left"
            >
              Browse Files
            </Button>
            <Button
              variant="outline"
              onClick={() => {/* Handle cloud import */}}
              iconName="Cloud"
              iconPosition="left"
            >
              Import from Cloud
            </Button>
          </div>
        </div>
      </div>
      
      {isUploading && (
        <div className="mt-4 p-4 bg-muted/30 rounded-lg">
          <div className="flex items-center space-x-3">
            <div className="animate-spin">
              <Icon name="Loader2" size={16} className="text-primary" />
            </div>
            <span className="text-sm text-foreground">Uploading documents...</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default DocumentUploadZone;